const signderivaType = require('./type')

class signderivaTypeDateTimePicker extends signderivaType {

}

module.exports = {
  code: 'DateTimePicker',
  description: 'Date & Time Picker',
  class: signderivaTypeDateTimePicker
}
